import { post } from 'api/utils';

export async function getUrl(name, fileType, resource = 'common') {
  return post(
    `/uploads/createSignUrl`,
    {
      resource,
      name: name,
      fileType: fileType,
    },
    {},
    '',
  );
}

export function uploadMedia(url, data) {
  return new Promise<XMLHttpRequest>((resolve, reject) => {
    const xhr = new XMLHttpRequest();

    xhr.onreadystatechange = function () {
      if (xhr.readyState === 4) {
        if (xhr.status === 200) {
          console.log('File successfully uploaded!');
          resolve(xhr);
        } else {
          reject(new Error('Upload failed with status: ' + xhr.status));
        }
      }
    };

    xhr.open('PUT', url, true);

    xhr.send(data);
  });
}
